import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


// const AuthRouter = ['login', 'register', 'forget', 'reset', 'user', 'avatar', 'nick', 'phone', 'password'];

// let AuthRouterList = AuthRouter.map(e => {
// 	return { path: '/' + e, name: e, component: () => import('../views/Auth.vue') }
// })

const routes = [
	{
		path: '/hand',
		name: 'hand',
		component: () => import('../views/hand.vue'),
		meta: {
			title: ''
		}
	},
	{
		path: '/getMiao',
		name: 'getMiao',
		component: () => import('../views/miaomiao/getMiao.vue'),
	},
	{
		path: '/ranking',
		name: 'ranking',
		component: () => import('../views/miaomiao/ranking.vue'),
	},
	{
		path: '/rainAward',
		name: 'rainAward',
		component: () => import('../views/miaomiao/rainAward.vue'),
	},
	{
		path: '/playingMethod',
		name: 'playingMethod',
		component: () => import('../views/miaomiao/playingMethod.vue'),
	},
	{
		path: '/girlActivity',
		name: 'girlActivity',
		component: () => import('../views/girlsDay/girlActivity.vue'),
	},
	{
		path: '/loveTask',
		name: 'loveTask',
		component: () => import('../views/girlsDay/loveTask.vue'),
	}
	,
	{
		path: '/girlActivityWeb',
		name: 'girlActivityWeb',
		component: () => import('../views/girlsDay/girlActivityWeb.vue'),
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('../views/index.vue'),
	}
	
]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
